export default {
	repUsers: [],
    repUserSearch: [],
	customerUsers: [],
	customerUserSearch: [],
	specificUsers: [],
	specificUserSearch: [],
	publicUsers: [],
	publicUserSearch: [],
	vendorUsers: [],
	vendorUserSearch: [],
    objUserSettings: '',
	objUserNotifications: [],
	objUserPricelists: [],
	objUserStatus: [],
	objUserCompanies: [],
	currentUserCompany: '',
    currentCompany: [],
	currentUser: [],
	currentRegions: [],
	userCompanies: [],
	userCustomers: [],
    userReps: [],
	overrideSettings: [],
	userLinks: 'none',
	userAddRoles: [],
	userAddCompanies: [],
	objUserEdit: [],
	objCompanyEdit: [],
	userRegions: [],
	userVendors: [],
	repsLoaded: false,
	customersLoaded: false,
	publicLoaded: false,
	specifierLoaded: false,
	vendorLoaded: false,
  userLoading: false,
  quoteNo: '',
  publicTotatlPages: null,
  leadUserSelected: '',
  newLeadUsers: [],
  userAvatar: '',
  repsShortList: []
}
